import { IUserAccountGeneral } from '@/modules/users/types';
import { axios } from '@/utils';
import {UserResponse} from "@/services/types";

export const getUserById = async (id: string) => (await axios.get(`/users/${id}`)).data.data;
export const login = async (values : any) => (await axios.post('/users/login',values)).data.data;
export const refresh = async (refreshToken :any) => (await axios.post('/users/refresh',{refreshToken})).data;
export const me = async () => (await axios.get('/users/me')).data.data;
export const getUserUid = async (uid: string): Promise<UserResponse> => (await axios.get(`/users/uid/${uid}`)).data.data;
export const getUsersService = async () => (await axios.get('/users')).data.data;
export const postUsersService = async (values: any) => {
  try {
    const { data } = await axios.post('/users', { ...values, rol: Number(values.rol) });
    return data.data;
  } catch (e: any) {
    const { message: code } = e;
    const message = errors[code] || 'Something went wrong';
    throw message;
  }
};

export const putUsers = (id: string) => async (body: IUserAccountGeneral) => {
  try {
    const { data } = await axios.put(`/users/${id}`, body);
    return data.data;
  } catch (e: any) {
    if (e.error) {
      const { code } = e.error;
      const message = errors[code] || 'Something went wrong';

      throw message;
    }

    throw 'Something went wrong';
  }
};
export const putUsersRole = (id: string) => async (body: IUserAccountGeneral) => {
  try {
    const { data } = await axios.put(`/users/role/${id}`, body);
    return data.data;
  } catch (e: any) {
    if (e.error) {
      const { code } = e.error;
      const message = errors[code] || 'Something went wrong';

      throw message;
    }

    throw 'Something went wrong';
  }
};

export const getRoles = async () => (await axios.get('/rol')).data.data;
export const findUsersByBranch = async () => (await axios.get('/users/branch')).data.data;
export const deleteUser = async (id: string) => (await axios.delete(`/users/${id}`)).data.data;

const errors: Record<string, string> = {
  'auth/email-already-exists': 'Email already exists',
  'auth/invalid-email': 'Invalid email address',
  'auth/invalid-password': 'Invalid password',
  'auth/invalid-phone-number': 'Invalid phone number',
  'auth/invalid-uid': 'Invalid uid',
  'auth/invalid-user-import': 'Invalid user import',
  'auth/invalid-provider-id': 'Invalid provider id',
  'auth/invalid-verification-code': 'Invalid verification code',
  'auth/phone-number-already-exists': 'Phone Number already exist',
  'not-found-rol': 'rol invalido',
};
